import axios, { AxiosInstance } from 'axios';
import { IResponsePadrao } from '../types/response-padrao';
import { getConfig } from '../utils/get-config';
export abstract class BaseApi<T> {
  protected api: AxiosInstance;
  protected path: string;
  constructor(path: string) {
    this.api = axios.create({
      baseURL: getConfig('REACT_APP_API_URL'),
      //baseURL: 'https://vendepay-hmg-backend-985d04b9215f.herokuapp.com',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true',
      },
    });
    this.path = path;
  }

  async show(id: string): Promise<IResponsePadrao<T>> {
    return (await this.api.get(`${this.path}/${id}`)).data;
  }

  async store(data: T): Promise<IResponsePadrao<T>> {
    return (await this.api.post(`${this.path}`, data)).data;
  }

  async destroy(id: string): Promise<IResponsePadrao<T>> {
    return (await this.api.delete(`${this.path}/${id}`))?.data;
  }
}
